import React, { useEffect, useState } from "react";
import useUrl from "../../../hook/useUrl";
import Uusimmat from "../../story-templates/uusimmat";
import VideoList from "../../story-templates/video-list";
import IlkkaPohjalainenList from "../../story-templates/ilkka-pohjalainen-list";
import { WithLazy } from "@quintype/components";
import { Tyopaikat } from "../../atoms/tyopaikat";
import { Newsletter } from "../../atoms/newsletter";
import { IppeBanner } from "../../atoms/ippebanner";
import { Podcast } from "../../atoms/podcast";
import SidebarBox from "../../atoms/sidebar-box";
//import { Lounaspaikka } from "../../atoms/lounaspaikka";
import SidebarList from "../../story-templates/sidebar-list";
import { LounaspaikkaBanner } from "../../atoms/lounaspaikka-banner";
import ChartbeatStories from "../../story-templates/chartbeat-stories";
import { VaasaSidebarBanner } from "../../atoms/vaasa-ads/vaasa-sidebar-banner";
import "./sidebar.m.css";

const SideBar = ({ useCollection, pageType }) => {
  // Check if the current path is the front page
  const [isFrontPage, setIsFrontPage] = useState(false);
  const [isBannerPage, setIsBannerPage] = useState(false);
  const [isCitypaperSectionPage, setIsCitypaperSectionPage] = useState(false);
  const [isStoryPage, setIsStoryPage] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      //console.log("window.location.pathname", window.location.pathname);
      setIsFrontPage(window.location.pathname === '/'
        || window.location.pathname === '/vaasalehti'
        || window.location.pathname === '/vaasalehti/'
        || window.location.pathname === '/epari'
        || window.location.pathname === '/epari/'
      );
    }
    if (typeof window !== 'undefined') {
      setIsBannerPage(window.location.pathname.includes('/bannerit'));
    }
    setIsStoryPage(pageType === "story");
    setIsCitypaperSectionPage(pageType === "section");
  }, []);

  const [, currentUrlSlug] = useUrl();
  function firstList(urlPattern) {
    const [isDisplayed, setIsDisplayed] = useState(false);
    useEffect(() => {
      let isMounted = true;

      setTimeout(() => {
        setIsDisplayed(true);
      }, 0);
      return () => {
        isMounted = false;
      };
    }, [])
    if (isDisplayed === true) {
      switch (urlPattern) {
        case "vaasalehti":
          return (
            <>
              {(isStoryPage) && ( //Show IlkkaPohjalainenList highest up in SidebarList on story pages (only on mobile)
              <div styleName="ip-list-story-page-mobile">
                <IlkkaPohjalainenList />
              </div>)}
              {/*<VaasaSidebarBanner />*/}
              <SidebarList paakirjoitus />
            </>
          );
        case "epari":
          return (
            <>
              {(isStoryPage) && ( //Show IlkkaPohjalainenList highest up in SidebarList on story pages (only on mobile)
                <div styleName="ip-list-story-page-mobile">
                  <IlkkaPohjalainenList />
                </div>)}
              <SidebarList paakirjoitus />
            </>
          );
        default:
          return (
          (isFrontPage || isBannerPage) ?
            <Uusimmat collectionslug={useCollection ? useCollection : ""} /> :
            <div className="suosituimmat-sidebar" styleName="suosituimmat-sidebar">
              <ChartbeatStories />
            </div>
          )
      }
    }
    else {
      return null;
    }
  }
  function generateLocalContents(urlPattern) {
    switch (urlPattern) {
      case "vaasalehti":
        return (
          <>
            {(isFrontPage || isCitypaperSectionPage || isStoryPage) && (
              <div styleName={isFrontPage ? "ip-list-front-page" : isCitypaperSectionPage ? "ip-list-section-pages" : "ip-list-story-page-desktop"}>
                <IlkkaPohjalainenList />
              </div>
            )}
            <SidebarList kolumnit />
            <SidebarList sports />
            <LounaspaikkaBanner />
          </>
        );
      case "epari":
        return (
          <>
            {(isFrontPage || isCitypaperSectionPage || isStoryPage) && (
              <div styleName={isFrontPage ? "ip-list-front-page" : isCitypaperSectionPage ? "ip-list-section-pages" : "ip-list-story-page-desktop"}>
                <IlkkaPohjalainenList />
              </div>
            )}
            <SidebarList kolumnit />
            <SidebarList yleisolta />
            <LounaspaikkaBanner />
          </>
        );
      default:
        return null;
    }
  }
  return (
    <div styleName="sidebar-container">
      <div styleName="sidebar">
        {/* Pystyparaati 2 deskari*/}
        <div styleName="pystyparaati pystyparaati1">
          <div id="sas_63222" data-placement-id="2-mainospaikka-desktop"></div>
        </div>

        {/* Pystyparaati 2A deskari*/}
        <div styleName="pystyparaati">
          <div id="sas_120816" data-placement-id="2A-mainospaikka-desktop"></div>
        </div>
        {firstList(currentUrlSlug)}
        <div styleName="pystyparaati pystyparaati1">
          <div id="sas_113460" data-placement-id="2B-mainospaikka-desktop"></div>
        </div>
        <div styleName="pystyparaati">
          <div id="sas_129940" data-placement-id="2C-mainospaikka-desktop"></div>
        </div>
        {generateLocalContents(currentUrlSlug)}

        {((currentUrlSlug !== "vaasalehti") && (currentUrlSlug !== "epari")) && (
          <>

            {!(isFrontPage || isBannerPage) ?
              <Uusimmat collectionslug={useCollection ? useCollection : ""} /> :
              <div className="suosituimmat-sidebar-frontpage" styleName="suosituimmat-sidebar-frontpage">
                <ChartbeatStories />
              </div>
            }

            {/*(isFrontPage || isBannerPage) && (
              <div styleName="video-list">
                <VideoList />
              </div>)*/}
            <LounaspaikkaBanner />
            {/*<SidebarBox />*/}
            {/*<div styleName="podcast-banner">
              {<Podcast />}
            </div>*/}
            <Newsletter />
            <Tyopaikat />
            {/*<WithLazy margin="50px">{() => <Lounaspaikka />}</WithLazy>*/}
          </>
        )}
      </div>
    </div>
  );
};

export default SideBar;
